/* Collection pages: "Show more pieces" appends the next page instead of sending the visitor to page 2. */
(function () {
  if (customElements.get('mj-load-more')) return;
  var css = '.mj-load-more{display:grid;justify-items:center;gap:12px;margin-top:40px}.mj-load-more [data-next][aria-busy=true]{opacity:.6;pointer-events:none}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  customElements.define('mj-load-more', class extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('[data-next]');
      if (!this.link) return;
      this.onClick = this.onClick.bind(this);
      this.link.addEventListener('click', this.onClick);
    }
    disconnectedCallback() { if (this.link) this.link.removeEventListener('click', this.onClick); }
    onClick(e) {
      e.preventDefault();
      var link = this.link, self = this;
      if (link.getAttribute('aria-busy') === 'true') return;
      link.setAttribute('aria-busy', 'true');
      link.textContent = 'Loading…';
      var url = new URL(link.href, location.href);
      url.searchParams.set('section_id', this.dataset.section);
      var view = new URLSearchParams(location.search).get('view');
      if (view && !url.searchParams.get('view')) url.searchParams.set('view', view);
      fetch(url.toString(), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var target = document.getElementById(self.dataset.list);
          var source = doc.getElementById(self.dataset.list);
          if (!target || !source) throw new Error('list not found');
          var cards = source.querySelectorAll('product-card, .product-card');
          var first = null;
          cards.forEach(function (c) {
            var node = document.importNode(c, true);
            node.removeAttribute('reveal-on-scroll');
            target.appendChild(node);
            if (!first) first = node;
          });
          var nextMore = doc.querySelector('mj-load-more');
          var status = nextMore && nextMore.querySelector('[data-status]');
          if (status) self.querySelector('[data-status]').textContent = status.textContent;
          var nextLink = nextMore && nextMore.querySelector('[data-next]');
          if (nextLink) {
            link.href = nextLink.getAttribute('href');
            link.textContent = 'Show more pieces';
            link.removeAttribute('aria-busy');
          } else {
            link.remove(); self.link = null;
          }
          if (first) {
            var a = first.querySelector('a[href]');
            if (a) a.focus({ preventScroll: true });
          }
        })
        .catch(function () { location.href = link.href; });
    }
  });
})();
